import {Box} from "@mui/material";
import {type FC, memo} from "react";
import {NotificationAlert} from "services/notification/NotificationAlert";

import {useNotifications} from "services/notification/useNotifications";

const containerSx = {
  position: "fixed",
  bottom: 16,
  right: 16,
  zIndex: 9999,
  maxWidth: 400,
  width: "100%",
};

export const NotificationSystem: FC = memo(() => {
  const {notifications, removeNotification} = useNotifications();

  if (!notifications.length) return null;

  return (
    <Box sx={containerSx}>
      {notifications.map(n => (
        <NotificationAlert
          key={n.id}
          notification={n}
          onClose={removeNotification}
        />
      ))}
    </Box>
  );
});
